module.exports = __webpack_public_path__ + "img/30.bc20bb2e.png";